import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { useState } from "react";
import { useNavigate } from "react-router";
import { useAlert } from "../../shared/alert-context";
import { appTheme } from "../../shared/theme/app-theme";
import { AuthService } from "./login-service";
import { ResetDTO } from "./model";
import { Link } from "@mui/material";

export default function ResetPage() {
  const [error, setError] = useState("");
  const [resetDto, setResetDto] = useState<ResetDTO>({ login: "", email: "" });
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const doReset = () => {
    AuthService.resetPassword(resetDto).then(
      () => {
        showAlert("Инструкция отправлена на вашу почту!", "success");
        navigate("/login");
      },
      () => {
        setError("Не удалось отправить инструкцию. Проверьте данные.");
      }
    );
  };

  return (
    <ThemeProvider theme={appTheme}>
      <CssBaseline />
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: 2,
          backgroundColor: "background.default",
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: 400,
            bgcolor: "background.paper",
            border: "1px solid",
            borderColor: "divider",
            borderRadius: 2,
            px: { xs: 3, sm: 4 },
            py: { xs: 4, sm: 5 },
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              mb: 3,
              gap: 1,
            }}
          >
            <Box
              component="img"
              src="/logo-ru.svg"
              alt="Қаржы орталығы"
              sx={{
                height: 44,
                width: "auto",
                maxWidth: 200,
                objectFit: "contain",
              }}
            />
            <Typography
              sx={{
                fontSize: 13,
                fontWeight: 600,
                letterSpacing: "0.14em",
                textTransform: "uppercase",
                color: "text.secondary",
              }}
            >
              ИС ГЗС
            </Typography>
          </Box>
          <Typography
            component="h1"
            sx={{
              fontSize: 20,
              fontWeight: 600,
              color: "text.primary",
              mb: 0.5,
            }}
          >
            Восстановление пароля
          </Typography>
          <Typography
            sx={{
              fontSize: 13,
              color: "text.secondary",
              mb: 3,
              textAlign: "center",
            }}
          >
            Укажите логин и почту учётной записи
          </Typography>

          <Box sx={{ width: "100%" }}>
            <TextField
              margin="dense"
              required
              fullWidth
              size="small"
              id="username"
              label="Логин"
              name="username"
              autoComplete="username"
              autoFocus
              sx={{ mb: 1.5 }}
              onChange={(e) =>
                setResetDto({ ...resetDto, login: e.target.value })
              }
            />
            <TextField
              margin="dense"
              required
              fullWidth
              size="small"
              id="email"
              label="Почта"
              name="email"
              autoComplete="email"
              onChange={(e) =>
                setResetDto({ ...resetDto, email: e.target.value })
              }
            />
            {error ? (
              <Typography sx={{ color: "error.main", fontSize: 13, mt: 1.5 }}>
                {error}
              </Typography>
            ) : null}
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
                mt: 1,
              }}
            >
              <Link
                href="/login"
                underline="hover"
                sx={{ fontSize: 13 }}
              >
                Войти в систему
              </Link>
            </Box>
            <Button
              fullWidth
              variant="contained"
              sx={{
                mt: 2.5,
                mb: 0.5,
                height: 42,
                textTransform: "none",
                fontWeight: 600,
              }}
              onClick={() => doReset()}
            >
              Восстановить пароль
            </Button>
          </Box>
        </Box>
      </Box>
    </ThemeProvider>
  );
}
